"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMOpcodeMapStorage = void 0;
const inversify_1 = require("inversify");
const MapStorage_1 = require("../MapStorage");
const VMOpCode_1 = require("../../enums/vm-transformers/VMOpCode");
const VMConstants_1 = require("../../constants/VMConstants");
let VMOpcodeMapStorage = class VMOpcodeMapStorage extends MapStorage_1.MapStorage {
    constructor() {
        super(...arguments);
        this.opcodeRange = VMConstants_1.VM_OPCODE_COUNT;
    }
    initialize() {
        super.initialize();
        this.generateRandomizedMapping();
    }
    generateRandomizedMapping() {
        this.storage.clear();
        const logicalOpcodes = Object.values(VMOpCode_1.VMOpCode).filter((value) => typeof value === 'number');
        const availableValues = [];
        for (let i = 0; i < this.opcodeRange; i++) {
            availableValues.push(i);
        }
        for (let i = availableValues.length - 1; i > 0; i--) {
            const j = Math.floor(this.randomGenerator.getMathRandom() * (i + 1));
            [availableValues[i], availableValues[j]] = [availableValues[j], availableValues[i]];
        }
        logicalOpcodes.forEach((logicalOpcode, index) => {
            this.storage.set(logicalOpcode, availableValues[index]);
        });
    }
    getRandomizedOpcode(logicalOpcode) {
        const randomizedOpcode = this.get(logicalOpcode);
        if (randomizedOpcode === undefined) {
            throw new Error(`No randomized opcode found for logical opcode ${logicalOpcode}`);
        }
        return randomizedOpcode;
    }
    getMappingObject() {
        const mapping = {};
        this.storage.forEach((randomizedOpcode, logicalOpcode) => {
            mapping[logicalOpcode] = randomizedOpcode;
        });
        return mapping;
    }
    generateNewMapping() {
        const mapping = {};
        const logicalOpcodes = Object.values(VMOpCode_1.VMOpCode).filter((value) => typeof value === 'number');
        const availableValues = [];
        for (let i = 0; i < this.opcodeRange; i++) {
            availableValues.push(i);
        }
        for (let i = availableValues.length - 1; i > 0; i--) {
            const j = Math.floor(this.randomGenerator.getMathRandom() * (i + 1));
            [availableValues[i], availableValues[j]] = [availableValues[j], availableValues[i]];
        }
        logicalOpcodes.forEach((logicalOpcode, index) => {
            mapping[logicalOpcode] = availableValues[index];
        });
        return mapping;
    }
};
exports.VMOpcodeMapStorage = VMOpcodeMapStorage;
__decorate([
    (0, inversify_1.postConstruct)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], VMOpcodeMapStorage.prototype, "initialize", null);
exports.VMOpcodeMapStorage = VMOpcodeMapStorage = __decorate([
    (0, inversify_1.injectable)()
], VMOpcodeMapStorage);
